import React from 'react'

import Image from '@/image.js'

const Perks = ({ content }) => {
  return (
    <div className='container--xl p15 ma ac'>
      <h2>{content.title}</h2>
      <div className='perk__grid f fw jcc aic'>
        {content.perks.map(perk => (
          <div key={perk._key} className='perk__grid-single x mb1'>
            <div className='f jcc aic'>
              <div className='perk__grid-icon-wrapper bcw f jcc aic'>
                <div className='perk__grid-icon rel z1 f jcc aic'>
                  <Image imageId={perk.imageId} width={100} className='x' />
                </div>
              </div>
            </div>
            <p className='mxa'>{perk.description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Perks
